import React from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'
import TeamListSection from './components/TeamListSection'
import ExternalScripts from '../../common/ExternalScripts'

const TeamList = () => {
  return (
    <div>
      <Header preclass="modified" modifiedHeader={true} />
      <ExternalScripts/>
      <TeamListSection/>
      <Footer/>
    </div>
  )
}

export default TeamList
